module.exports = __webpack_public_path__ + "static/media/twa_sat.f0e5706a.png";